import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AiInput } from '@/shared/ui';

type BlockPointsFieldProps = {
  maxPoints: number | null;
  possiblePoints: number[] | null;
  /** Справочник, которым блок оценивается вместо баллов */
  possibleValues: string[] | null;
  isProcessing: boolean;
};

/**
 * Чем оценивается листовой блок: баллами (максимальный и перечень возможных) либо справочником
 * значений. И то, и другое определяет сервер по правилам блока, поэтому поле недоступно для ввода;
 * размерность, в которой читается балл, стоит отдельным полем — её пользователь правит сам.
 */
export const BlockPointsField: FC<BlockPointsFieldProps> = ({
  maxPoints,
  possiblePoints,
  possibleValues,
  isProcessing,
}) => {
  const { t } = useTranslation('expertReport');

  const getValue = () => {
    if (possibleValues?.length) return t('pointsPossibleValues', { values: possibleValues.join(', ') });
    if (maxPoints === null) return '';
    return !possiblePoints?.length
      ? t('pointsMaxOnly', { max: maxPoints })
      : t('pointsValue', { max: maxPoints, possible: possiblePoints.join(', ') });
  };

  return (
    <AiInput
      label={t('points')}
      value={getValue()}
      placeholder={t('pointsNotResolved')}
      disabled
      isProcessing={isProcessing}
    />
  );
};
